<router-outlet>
  <app-spinner />
</router-outlet>
